// Data events are bound to a unique URL handler
export const DATA_EVENTS = {
  ACCOUNT_LOG_IN: 'account-log-in',
  ACCOUNT_REGISTRATION: 'account-registration',
  BOOKING_COMPLETE: 'booking-complete',
  BOOKING_START: 'booking-start',
  EVENT_CHARITY_ENTRY: 'charity-entry',
  EVENT_REVIEW: 'event-review',
  EVENT_SAVE: 'event-save',
  EVENT_SHARE: 'event-share',
  EVENT_TICKETS: 'event-tickets',
  EVENT_UNSAVE: 'event-unsave',
  EVENT_VISIT: 'event-visit',
  EXTERNALBOOKING_SAVE: 'externalbooking-save',
  EXTERNALBOOKING_UNSAVE: 'externalbooking-unsave',
  TICKET_CLICK_OUT: 'ticket-click-out',
  LOGIN_WALL_VIEWED: 'login-wall-viewed',
};

// Segment events are passed directly to segment using the `trackEvent` method.
// RENAME_CANDIDATE: events which need to be renamed when refactoring our data layer.
// Note: At Jonathan's request, we are consolidating events and putting more information
// into the name/action/context. If you do not know what these are, ask around before editing this.
export const SEGMENT_EVENTS = {
  ACCOUNT_CREATED_CLIENT_SIDE: 'Account Created (client-side)', // RENAME_CANDIDATE: Remove (client-side), make more specific instead.
  ACTIVE_TICKET_CLICKOUT_CLIENT_SIDE: 'Active Ticket Clickout (client-side)', // RENAME_CANDIDATE: Remove (client-side)
  BANNER_APPEARED: 'Banner Appeared',
  BOOKING_PROGRESS: 'Booking form progress',
  BOOKING_COMPLETED_CLIENT_SIDE: 'Booking Completed (client-side)', // RENAME_CANDIDATE: Remove (client-side), make more specific instead.
  BOOKING_EMAIL_ENTERED: 'Booking Email Entered',
  BOOKING_SHARED: 'Booking Shared',
  BOOKING_STARTED_CLIENT_SIDE: 'Booking Started (client-side)', // RENAME_CANDIDATE: Remove (client-side), make more specific instead.
  BUTTON_CLICKED: 'Button Clicked', // RENAME_CANDIDATE: Not specific enough.
  CAROUSEL_VIEWED: 'Carousel Viewed',
  CHARITY_TICKET_CLICKOUT_CLIENT_SIDE: 'Charity Ticket Clickout (client-side)', // RENAME_CANDIDATE: Remove (client-side)
  COMMUNITY_BUTTON_CLICKED: 'CommunityButton clicked', // RENAME_CANDIDATE: Spacing, Cases, and potential replacable by REVIEW_BUTTON_CLICKED
  COMPONENT_CLICKED: 'Component Clicked',
  DIRECTIONS: 'Directions',
  DIRECTIONS_REQUESTED: 'Directions requested on event page',
  EMAIL_SUBMITTED: 'Email Submitted',
  EMAIL_UNSUBSCRIBED: 'Email Unsubscribed',
  EVENT_QUESTION_ASKED: 'Event Question Asked',
  EVENT_LINK_CLICKED: 'Event link clicked',
  EVENT_VISITED_CLIENT_SIDE: 'Event Visited (client-side)', // RENAME_CANDIDATE: Remove (client-side), make more specific instead.
  EVENT_SHARED: 'Event shared',
  FEATURED_EVENTS_VIEWED: 'Featured Events Viewed',
  FEEDBACK_REQUESTED: 'Feedback Requested',
  FEEDBACK_SUBMITTED: 'Feedback Submitted',
  FORM_SUBMITTED: 'Form Submitted',
  GROUP_SHARED: 'Group Shared',
  GEOLOCATION_ALLOWED: 'Geolocation Allowed',
  GEOLOCATION_DISALLOWED: 'Geolocation Disallowed',
  INPUT_ENTERED: 'Input Entered',
  LINK_STRAVA_BUTTON_CLICKED: 'Link Strava Button Clicked',
  MAP_MOVED: 'Map Moved',
  MAP_VIEW_TOGGLED: 'Event Search Map View Toggled',
  MODAL_SHOWN: 'Modal Shown',
  ONBOARDING: 'Onboarding',
  ORGANIZER_PANEL: 'Organizer Panel',
  PANEL_CLOSED: 'Panel Closed',
  PANEL_OPENED: 'Panel Opened',
  REACTION_GIVEN: 'Reaction Given',
  REVIEW_ANOTHER_EVENT_CLICKED: 'Review another event clicked', // RENAME_CANDIDATE: All words should be capitalised
  REVIEW_BUTTON_CLICKED: 'Review Button Clicked',
  REVIEW_LINK_CLICKED: 'Event Review Link Clicked',
  REVIEW_REQUESTED: 'Review Requested',
  REVIEW_STARTED: 'Review Started',
  REVIEW_SUMMARY_CLICKED: 'Review Summary Clicked',
  REVIEW_UNLOADED: 'Review Unloaded',
  SEARCH_FROM_REVIEW_PAGE: 'Search from review page', // RENAME_CANDIDATE: Doesn't follow Object-Action pattern
  SEARCH_RESULTS_VIEWED: 'Search Results Viewed',
  SERIES_SHARED: 'Series Shared',
  SHARING_MODAL_OPENED: 'Sharing Modal Opened',
  TAB_CLICKED: `Tab Clicked`, // We specify tab type on the page
  TEXT_FIELD_INTERACTED: `Text Field Interacted`,
  TEXT_SEARCH_ENTERED: 'Text Search Entered', // RENAME_CANDIDATE: Not specific enough
  TRAVEL_INFORMATION_EXPANDED: 'Travel information box expanded',
  USER_PROFILE_CLICKED: 'User Profile Clicked',
  WEBSITE_CLICKED_OUT: 'Website Clicked Out', // RENAME_CANDIDATE: Take's user to organiser page when no tickets.
  SIDE_PANEL_REVIEW_CLICK: 'Side Panel Review Clicked',
  EVENT_ANCHOR_DETAILS_CLICK: 'Event Anchor Details Clicked',
  EVENT_ANCHOR_OVERVIEW_CLICK: 'Event Anchor Overview Clicked',
  EVENT_ANCHOR_REVIEWS_CLICK: 'Event Anchor Reviews Clicked',
  TRAINING_TIME_TAG_CLICK: 'Training Time Tag Clicked',
  TRAINING_TIME_EXPERIMENT_VIEWED: 'Training Time Experiment Viewed',
  CHALLENGE_AWARDS_SHARED: 'Challenge Awards Shared',
  CHALLENGE_AWARDS_VOTED: 'Challenge Awards Voted',
  CHALLENGE_AWARDS_CLOSED_LOGIN_MODAL: 'Challenge Awards Closed Login Modal',
  SERIES_VISITED: 'Series Visited',
  SERIES_EVENT_CLICKED: 'Series Event Clicked',
};

export const getAllSegmentTrackingEvents = () => {
  const dataEvents = Object.values(DATA_EVENTS).reduce((acc, val) => {
    acc.push(val);
    return acc;
  }, []);
  const segmentEvents = Object.values(SEGMENT_EVENTS).reduce((acc, val) => {
    acc.push(val);
    return acc;
  }, []);
  return dataEvents.concat(segmentEvents);
};
export const PAGE_NAME = {
  ABOUT_US_PAGE: 'About Us',
  BOOKING_FORM_PAGE: 'Booking Form',
  BRAND_PARTNERS_PAGE: 'Brand Partners',
  CATEGORY_PAGE: 'Category Viewed', // RENAME_CANDIDATE: Page events don't need action, they imply a view
  EMAIL_PREFERENCES_PAGE: 'Email Preferences',
  EVENT_CHARITY_ENTRY_PAGE: 'Event Charity Entry',
  EVENT_PAGE: 'Event',
  EVENT_REVIEW_PAGE: 'Event Review',
  EVENT_REVIEW_SUCCESS_PAGE: 'Event Review Success',
  EVENT_SEARCH_PAGE: 'Event Search',
  EVENT_TICKETS_PAGE: 'Event Tickets',
  FINISH_LINE_PAGE: 'Finish Line',
  JOIN_GROUP_EVENT_PAGE: 'Join Group Event',
  JOIN_GROUP_PAGE: 'Join Group',
  HOMEPAGE_PAGE: 'Homepage',
  LABS: 'Labs',
  LEADERBOARDS_PAGE: 'Leaderboards',
  LOGIN_PAGE: 'Login',
  LOGIN_CALLBACK_PAGE: 'Login Callback',
  LONDON_MARATHON_COMPETITION_DASHBOARD_PAGE:
    'London Marathon Competition Dashboard',
  LONDON_MARATHON_COMPETITION_LOGIN_PAGE: 'London Marathon Competition Login',
  ORGANISER_PAGE: 'Organiser',
  PROFILE_SETTINGS_PAGE: 'Profile Settings',
  MY_EVENT_PAGE: 'My Event Detail',
  MY_EVENTS_PAGE: 'My Events',
  SERIES_PAGE: 'Series',
  SQUADS_ACCEPT_INVITE_PAGE: 'Squads Accept Invite',
  SOCIAL: 'Social',
};
export const getAllPageEvents = () => {
  return Object.values(PAGE_NAME).reduce((acc, val) => {
    acc.push(val);
    return acc;
  }, []);
};
